export default __webpack_public_path__ + "static/media/8.7c087dc1.webp";